import { FC, useCallback, useMemo, useState } from 'react';
import Icon from '../Icon';
import Typography from '../Typography';

import './NavigationSubmenuItem.scss';
import Link from '../Link';
import { matchPath, useLocation } from 'react-router-dom';

interface NavigationSubmenuItemProps {
  expanded: boolean;
  variant?: 'mobile' | 'desktop';
  onNavigate?: () => void;
}

const NavigationSubmenuItem: FC<NavigationSubmenuItemProps> = ({ expanded, variant = 'desktop', onNavigate }) => {
  const location = useLocation();

  const [open, setOpen] = useState(false);

  const isActive = useCallback((currentRoute: string) => !!matchPath(currentRoute, location.pathname), [location]);

  const toggleOpen = useCallback(() => {
    setOpen(prevOpen => !prevOpen);
  }, []);

  const highlightMainLabel = useMemo(() => {
    return isActive('/uno') || isActive('/points') || isActive('/stake') || isActive('/changelog');
  }, [isActive]);

  return (
    <div className="nostra__navigationSubmenuItem__container">
      <div className="nostra__navigationSubmenuItem" onClick={toggleOpen} data-variant={variant}>
        <div className="nostra__navigationSubmenuItem__labelContainer" data-variant={variant}>
          <div className="nostra__navigationSubmenuItem__icon" data-variant={variant}>
            <Icon
              variant="more"
              size={variant === 'desktop' ? 16 : 20}
              color={highlightMainLabel ? '--text-primary-darkbg' : '--icon-supporting'}
            />
          </div>
          <Typography
            variant={variant === 'desktop' ? 'nav-item' : 'body-lg'}
            weight={variant === 'desktop' ? 'regular' : 'semi-bold'}
            color="text-supporting-darkbg"
            className="nostra__navigationSubmenuItem__label"
          >
            More
          </Typography>
        </div>
        <Icon
          variant={open && expanded ? 'up-chevron' : 'down-chevron'}
          size={variant === 'desktop' ? 14 : 24}
          color="--primary-400"
        />
      </div>
      {open && expanded && (
        <div className="nostra__navigationSubmenuItem__list" data-variant={variant}>
          <Link href="/stake" className="nostra__navigationSubmenuItem__listItem" onClick={onNavigate}>
            <Typography
              variant={variant === 'desktop' ? 'nav-item' : 'body-lg'}
              color={isActive('/stake') ? 'text-primary-darkbg' : 'text-supporting-darkbg'}
              weight={isActive('/stake') ? 'semi-bold' : 'regular'}
            >
              Stake
            </Typography>
          </Link>
          <Link href="/uno" className="nostra__navigationSubmenuItem__listItem" onClick={onNavigate}>
            <Typography
              variant={variant === 'desktop' ? 'nav-item' : 'body-lg'}
              color={isActive('/uno') ? 'text-primary-darkbg' : 'text-supporting-darkbg'}
              weight={isActive('/uno') ? 'semi-bold' : 'regular'}
            >
              UNO
            </Typography>
          </Link>
          <Link href="/points" className="nostra__navigationSubmenuItem__listItem" onClick={onNavigate}>
            <Typography
              variant={variant === 'desktop' ? 'nav-item' : 'body-lg'}
              color={isActive('/points') ? 'text-primary-darkbg' : 'text-supporting-darkbg'}
              weight={isActive('/points') ? 'semi-bold' : 'regular'}
            >
              Points
            </Typography>
          </Link>
          <Link href="/changelog" className="nostra__navigationSubmenuItem__listItem" onClick={onNavigate}>
            <Typography
              variant={variant === 'desktop' ? 'nav-item' : 'body-lg'}
              color={isActive('/changelog') ? 'text-primary-darkbg' : 'text-supporting-darkbg'}
              weight={isActive('/changelog') ? 'semi-bold' : 'regular'}
            >
              Release Notes
            </Typography>
          </Link>
        </div>
      )}
    </div>
  );
};
export default NavigationSubmenuItem;
